import React, {FC, useContext} from 'react';
import {Button, Typography} from 'onboarding-components';
import {clsx} from 'clsx';

import {handleCompleteStep} from 'common/onboarding/immersive-onboarding/utils';
import {SetupGuideContext, Step} from 'common/onboarding/immersive-onboarding/types';
import {TrackingEvent} from 'common/onboarding/immersive-onboarding/tracking';
import {useTranslation} from 'common/i18n/hooks';
import common from 'iron/common/onboarding/immersive-onboarding/steps/common.module.styl';

import {InstallGuide} from './InstallGuide';

export const InstallJavascriptSDK: FC = () => {
  const {setStep, setupGuideInfo, setSetupGuideInfo, setSelectAltSDK} = useContext(SetupGuideContext);
  const {t} = useTranslation();

  const handleSelectDiffSDK = () => {
    handleCompleteStep({
      setupGuideInfo,
      setSetupGuideInfo,
      setStep,
      completedStep: Step.GetStarted,
      nextStep: Step.Connect,
      trackingEvent: TrackingEvent.SelectAlternateSDKClick,
    });

    setSelectAltSDK(true);
  };

  const handleBackToStart = () => {
    handleCompleteStep({
      setupGuideInfo,
      setSetupGuideInfo,
      setStep,
      completedStep: Step.GetStarted,
      nextStep: Step.GetStarted,
      trackingEvent: TrackingEvent.ReturnToStart,
    });

    setSelectAltSDK(false);
  };

  const handleVerifyConnection = () => {
    handleCompleteStep({
      setupGuideInfo,
      setSetupGuideInfo,
      setStep,
      completedStep: Step.Connect,
      nextStep: Step.Verify,
      trackingEvent: TrackingEvent.VerifyConnection,
    });

    setSelectAltSDK(false);
  };

  return (
    <div className={common.container}>
      <header className={common.mb24}>
        <div className={clsx(common.headerRow, common.mb4)}>
          <Typography className={common.mt0} variant='headingSm'>
            {t(`onboarding.welcome.install-sdk`)}
          </Typography>
          <div className={clsx(common.label, common.labelMint)}>
            <Typography variant='captionXs' weight='bold'>
              {t(`onboarding.welcome.quick-start-label`)}
            </Typography>
          </div>
        </div>
        <button className={common.textLinkButton} onClick={handleSelectDiffSDK}>
          <Typography variant='captionXs' weight='bold'>
            {t(`onboarding.welcome.select-dif-sdk`)}
          </Typography>
        </button>
      </header>

      <InstallGuide />

      <div className={clsx(common.buttonGroup, common.mt42)}>
        <Button variant='transparent' size='small' onClick={handleBackToStart}>
          {t(`onboarding.sidenav.go-back`)}
        </Button>
        <Button variant='solid' size='small' onClick={handleVerifyConnection}>
          {t(`onboarding.sidenav.verify-connection`)}
        </Button>
      </div>
    </div>
  );
};
